import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const arLinkOutsBlockCss = css`
  /* Override Block's default background color */
  --bg-color: var(--custom-bg-color);

  /* Increase specificity to override default Block styles */
  &&& {
    background-color: var(--custom-bg-color);
  }

  /* Target the block-children section to make it a flex container */
  section[data-testid='sdsm-block-children'] {
    display: flex;
    flex-wrap: wrap;
    gap: ${m('--spacing-xl')};
  }

  /* Target each content card to apply the flex value */
  section[data-testid='sdsm-block-children'] > .sdsm-content {
    /* Flex value will be set inline via style prop on the Content component */
    min-width: 0; /* Prevent flex items from overflowing */
  }
`;

export const createCtaContainerCss = (color?: string, textColor?: string) => css`
  display: flex;
  justify-content: center;
  gap: ${m('--spacing-m')};
  width: 100%; /* Force CTAs to next row */
  flex-shrink: 0;

  ${color && textColor
    ? `
  & > a[class*='button'] {
    background-color: ${color};
    border: 2px solid ${color};
    color: ${textColor};
    padding: 11px 31px;
    border-radius: 64px;
  }

  & > a[class*='button']:hover {
    background-color: ${color};
    border-color: ${color};
    color: ${textColor};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

  & > a[class*='button']:active {
    background-color: ${color};
    border-color: ${color};
    color: ${textColor};
    transform: translateY(-1px);
  }
  `
    : ''}
`;
